import { useHistoricoPraticados } from '@/api/lista-precos';
import { ErroFormacao } from '@/components/formacao/avisos-formacao';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet';
import { formatarDataHora, formatarMoeda } from '@/lib/format';

export interface AlvoHistorico {
  itemId: string;
  tabelaId: string;
  condicaoId: string;
  codigo: string;
  descricao: string;
  tabelaCodigo: string;
}

/** Historico de preços praticados do item na tabela (append-only: cada alteração é um registro novo). */
export function HistoricoPraticados({ alvo, onFechar }: { alvo: AlvoHistorico | null; onFechar: () => void }) {
  const hist = useHistoricoPraticados(alvo ? { itemId: alvo.itemId, tabelaId: alvo.tabelaId, condicaoId: alvo.condicaoId } : null);
  return (
    <Sheet open={alvo !== null} onOpenChange={(aberto) => !aberto && onFechar()}>
      <SheetContent side="right" className="w-[420px] max-w-full gap-0 sm:max-w-[420px]">
        <SheetHeader>
          <SheetTitle>Histórico de praticados</SheetTitle>
          <SheetDescription>
            {alvo ? `${alvo.codigo} · ${alvo.descricao} · tabela ${alvo.tabelaCodigo}` : ''}
          </SheetDescription>
        </SheetHeader>
        <div className="px-4 pb-4">
          {hist.isError ? (
            <ErroFormacao erro={hist.error} onTentar={() => void hist.refetch()} />
          ) : hist.isPending ? (
            <p role="status" className="py-8 text-center text-small text-ink-muted">
              Carregando histórico…
            </p>
          ) : (hist.data ?? []).length === 0 ? (
            <p role="status" className="py-8 text-center text-small text-ink-muted">
              Nenhum preço praticado registrado para este item nesta tabela.
            </p>
          ) : (
            <ol aria-label="Preços praticados" data-testid="historico-praticados" className="flex flex-col divide-y divide-border">
              {(hist.data ?? []).map((h, i) => (
                <li key={h.id} className="flex items-baseline justify-between gap-3 py-2.5">
                  <div>
                    <div className="tabular text-body font-semibold text-ink">{formatarMoeda(h.preco)}</div>
                    <div className="text-caption text-ink-muted">
                      {formatarDataHora(h.recordedAt)}
                      {h.criadoPorNome ? ` · ${h.criadoPorNome}` : ''}
                    </div>
                  </div>
                  {i === 0 && <span className="rounded-full bg-success-bg px-2 text-caption leading-5 font-medium text-success-ink">Atual</span>}
                </li>
              ))}
            </ol>
          )}
        </div>
      </SheetContent>
    </Sheet>
  );
}
